import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconButtonComponent {
  @Input() text: string;
  @Input() icon: string;
  @Input() showArrow = false;
  @Input() disabled = false;
  @Input() ariaLabel: string;
}
